import './App.css';
import { useEffect, useState } from "react";


function App() {
  const [data, setData] = useState({ organizationData: {}, keyData: {}, isLoading: true });

  useEffect(() => {
    async function loadData() {
      try {
        let startLoadingData = { ...data }
        startLoadingData.isLoading = true
        setData(startLoadingData);
        const jointData = await fetchDataFromQueryStringParams()
        setData(jointData);
      } catch (err) {
        console.error(err);
      }
    }

    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // empty array → run once on mount
  if (data.isLoading) {
    return (
      <div className="App">
        <div className='App-header'>
          <p>Loading</p>
        </div>
        <footer>
          <p>Contact Phone Number: 9548052619</p>
          <p>Email: info@seasidepalms.com</p>
          <a href='SeasidePalms.com'>SeasidePalms.com</a>
          <div>
            <a href="https://www.communitytech.io">Privacy Policy</a>
            <a href="https://www.communitytech.io">Terms of Service</a>
          </div>
          <h4>Powered by Community Tech</h4>
        </footer>
      </div>
    );
  }
  let organizationLogoUrl = data.organizationData.organization_logo_url
  let organizationName = data.organizationData.organization_name
  let organizationPhone = data.organizationData.organization_phone
  let organizationEmail = data.organizationData.organization_email
  let organizationAddress = `${data.organizationData.organization_address} ${data.organizationData.organization_address_2} ${data.organizationData.organization_city} ${data.organizationData.organization_state},  ${data.organizationData.organization_zip}`
  let visitorName = `${data.keyData.visitor_first_name} ${data.keyData.visitor_last_name}`
  let keyType = `${data.keyData.key_type}`
  //let activeTime = new Date(data.keyData.time_active)
  let activeTime = new Date()
  //let expiration = data.keyData.expiration
  let expiration = new Date()
  expiration.setDate(expiration.getDate() + 2)
  let activeString = activeTime.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  let expirationString = expiration.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  let residentAddress = `${data.residentData.address}`
  let residentPhone = `${data.residentData.primary_phone_number}`

  let keyId = data.keyData.key_id
  let qrCodeApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${keyId}`
  return (
    <div className="App">
      <header className="App-header">
        <img src={organizationLogoUrl} className="communityImage" alt="logo" />
        <br />
        <b>Welcome to {organizationName}, {visitorName}</b>
        <img src={qrCodeApiUrl} className="qr-code" alt="logo" />
        <b>{keyId}</b>
        <br />
        <b>Please have your ID ready to show at the gate</b>

        <div className='keyInfo'>
          <p>{keyType} Key</p>
          <p>Valid: {activeString} - {expirationString}</p>
        </div>


        <button onClick={() => handleMapsDeeplink(organizationAddress)}>Directions to Gate</button>
        <button onClick={() => handleMapsDeeplink(residentAddress)}>Directions to Richard Dale</button>
        <button className="contact" onClick={() => initiateCall(residentPhone)}>Contact Richard Dale</button>

      </header>
      <footer className="App-footer">
        <div className='communityContact'>
          <p>Contact Phone Number: {organizationPhone}</p>
          <p>Email: {organizationEmail}</p>
          <p><a href='https://communitytech.io'>CommunityTech.io</a></p>
        </div>
        <div className='supplemental'>
          <a href="https://www.communitytech.io">Privacy Policy</a>
          <a href="https://www.communitytech.io">Terms of Service</a>
        </div>
        <h4 className='poweredBy'>Powered by Community Tech</h4>
      </footer>
    </div>
  );
}

async function fetchDataFromQueryStringParams() {
  const searchParams = new URLSearchParams(window.location.search);

  const keyId = searchParams.get('keyId');
  const organizationId = searchParams.get('organizationId');
  let organizationDataResponse = await fetch(`https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/organizations/${organizationId}`)
  let organizationData = await organizationDataResponse.json()
  let outputOrganizationData = organizationData.data[0]
  console.log("Organization Data", organizationData)
  let keyDataResponse = await fetch(`https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/${organizationId}/keys/${keyId}`)
  let keyData = await keyDataResponse.json()
  let outputKeyData = keyData.data[0]
  console.log("Key Data", keyData)
  let residentDataResponse = await fetch(`https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/${organizationId}/users/${outputKeyData.resident_uid}`)
  let residentData = await residentDataResponse.json()
  let outputResidentData = residentData.data[0]
  console.log("Resident Data", outputResidentData)


  return {
    organizationData: outputOrganizationData,
    keyData: outputKeyData,
    residentData: outputResidentData
  }
}

// const isAndroid = () => {
//   return /Android/i.test(navigator.userAgent);
// };

const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function handleMapsDeeplink(address) {
  let mapsUrl = ""
  if (isIOS()) {
    mapsUrl = "https://maps.apple.com/search?query=" + address
  } else {
    mapsUrl = "https://maps.google.com/?q=" + address
  }
  window.location = mapsUrl
}

function initiateCall(phoneNumber) {
  window.location.href = "tel:" + phoneNumber

}

export default App;
